var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadsmart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 44,
    viewBox: "0 0 44 44",
    width: 44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.4823722 2h26.8882209c.8998815 0 1.6294069.72952537 1.6294069 1.62940694v26.88822086h-13.8509611v-13.8509611c0-.4509429-.3647627-.8157056-.8157056-.8157056h-13.8509611zm-1.6314111 29.3333333c0 .4509429.3647627.8157056.8157056.8157056h28.5196319l-13.3759679 13.3739637c-.304637.304637-.7195044.4769974-1.1524096.4769974h-27.03051835c-.89787738 0-1.62740275-.7295254-1.62740275-1.6274028v-27.0305183c0-.4329052.17236039-.8457684.47699736-1.1524096l13.37396374-13.37596792z",
    fill: "#29d454",
    fillRule: "evenodd",
    transform: "translate(-2 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadsmart);
export default __webpack_public_path__ + "static/media/loadsmart.b4e75a9f0a88365b14f8a6895126889b.svg";
export { ForwardRef as ReactComponent };